import * as React from "react";
import { forwardRef } from "react";
import styled, { css } from "styled-components";
import { IconButton } from "components/common";
const Container = styled.div(
  ({ theme }) => css`
    display: flex;
    padding: 6px 5px 3px 7px;
    margin-bottom: 5px;
    border-radius: 3px;
    border: 1px solid ${theme.colors.variant.lighter.default};
    background-color: ${theme.colors.variant.lightest.default};
    flex-direction: column;
    position: relative;

    input {
      font-size: ${theme.fonts.size.body};
    }

    .control-label {
      padding-left: 0;
      padding-right: 5px;
      font-weight: normal;
    }
  `
);
const ElementActions = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: end;
  align-items: center;
  position: absolute;
  right: 0;
  top: 5px;
`;
const StyledIconButton = styled(IconButton)`
  width: fit-content;
  height: fit-content;
`;
const ElementConfiguration = styled.div`
  flex: 1;
  // The min-width is required to avoid an overflow problem with the parent component.
  min-width: 0;
`;
const ElementConfigurationContainer = ({ children, onRemove = void 0, dragHandle = void 0, className = void 0, elementTitle }, ref) => /* @__PURE__ */ React.createElement(Container, { className, ref }, /* @__PURE__ */ React.createElement(ElementActions, null, dragHandle, onRemove && /* @__PURE__ */ React.createElement(StyledIconButton, { size: "sm", onClick: onRemove, name: "delete", title: `Remove ${elementTitle}` })), /* @__PURE__ */ React.createElement(ElementConfiguration, null, children));
export default forwardRef(ElementConfigurationContainer);
